import type { Drone, ModelServiceIntervalMap, ServiceIntervalMap } from '../../types';
import { getModelIntervals } from '../getModelIntervals';

// Resolves a drone's effective service intervals — the map for its own model.
// A drone's wear must always compute against its model's intervals.
export const getDroneIntervals = ({
    drone,
    serviceIntervals
}: {
    drone: Drone;
    serviceIntervals: ModelServiceIntervalMap;
}): ServiceIntervalMap => getModelIntervals({ model: drone.model, serviceIntervals });
